export default __webpack_public_path__ + "static/media/classiclines.a8989626.jpg";